export default __webpack_public_path__ + "public/icons/LeftArrow.svg?a3c28b33a152dc0c50818401383e6b30";